<div class="banner">
    <div class="col-12 pb-5"><h1>Industry Reports</h1></div>
    <div class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'industry-reports-tab': ['brand-identification'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Brand Client Report</a></li>
            <li><a [routerLink]="[{ outlets: { 'industry-reports-tab': ['in-market-monitoring'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Monitoring Reports</a></li>
            <ng-template 
                [appAuthIfCombined]="[[CognitoGroup.Carrier, CognitoGroup.VettingMonitoring]]" >
                <li><a [routerLink]="[{ outlets: { 'industry-reports-tab': ['month-end-report'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Month End Summary Report</a></li>
            </ng-template>
            <li><a [routerLink]="[{ outlets: { 'industry-reports-tab': ['complaint-classification'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Consumer Complaints Report</a></li>
            <li><a [routerLink]="[{ outlets: { 'industry-reports-tab': ['vetting-insights'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Vetting Results Report</a></li>

        </ul>
    </div>
</div>
<div class="tabcontent">
    <router-outlet name="industry-reports-tab"></router-outlet>
</div>
